<template>

  <div class="tableContainerLucas">

  <table v-if="!loading" :id="'table_' + id" class="display dtLucas compact" width="100%">
      <thead>
        <tr class="trclass">
          <th v-for="column in columnListPretty" :key="column" class="thclass">
            {{ column }}
          </th>

          <slot name="extraColumnHeaders">

          </slot>
          
          <th tabindex="0" class="nosort actionHeader" ref="actionHeader" v-if="showActionColumn">Actions</th>
        </tr>
      </thead>
  
      <tbody>
        <tr v-for="row in loadedData" :key="row[columnNameId]">
          <td class="tdclass" v-for="column in columnListDB" :key="column" tabindex="0" >
            {{ row[column] }} 
          </td>


          <slot tabindex="0" name="extraColumns" v-bind="row"></slot>

          <slot tabindex="0" name="actionColumnEditSlot" v-bind="row" v-if="showActionColumn">

            <router-link :to="{ name: editRouteName, params: { id: row[columnNameId] } }" class="btn btn-primary editButton">Edit</router-link>

          </slot>

        </tr>
      </tbody>
    </table> 

    <LoadingGif v-show="loading"></LoadingGif>
  </div>
  
    
  </template>
  
<script>
  import $ from "jquery";
  import LoadingGif from "@/components/dataSupport/LoadingGif.vue";
  import { uuid } from "vue-uuid";
  import { ajaxDeleteHelper } from "../helpers/utilities";
  import { store } from "../../store/store.js";
  import "datatables.net-dt/js/dataTables.dataTables";
  import "datatables.net-dt/css/jquery.dataTables.min.css";

  window.jQuery = $; 
  
  export default {
    name: "DataTableComponent",
    data() {
      return {
        loading: true,
        allData:[],
        loadedData: [],
        dt: null,
        id: null,
        store,
        componentKey:uuid.v1(),
        dtSettings:{},
      };
    },
    props: {
      // list of column names as they appear on the DB/ how they will be returend by an AJAX call
      columnListDB: Array,
      // list of column names as we want them to appear to the user
      columnListPretty: Array,
      // url to retrieve data set
      dataUrl: String,
      // the route name of the edit page for a particular data item
      editRouteName: String,
      // the name identifier for the ID used by this table (for deleting, and editing)
      columnNameId: String,
      // the url of the ajax delete method for this table
      deleteActionUrl: String,
      showActionColumn:{
        type:Boolean, 
        default:true
      },
      centerColumnIndexes:{
        type:Array,
        default:new Array(),
      },
      dateColumnIndexes:{
        type:Array,
        default: new Array(),
      },
      orderColumnIndex:{
        type:Number, 
        default:0,
      },
      orderDirection:{
        type:String,
        default:"asc",
      },
      showSearch:{
        type:Boolean, 
        default:true
      },
      showPaging:{
        type:Boolean, 
        default:true
      },
      showInfo:{
        type:Boolean, 
        default:true
      },
      rowsPerPage:{
        type:Number,
        default:10
      },
      showLengthChange:{
        type:Boolean,
        default:true
      },
      pluralDataName:{
        type:String,
        default:"entries"
      }
    },
    computed:{
      
    },
    async created(){

      this.dtSettings = {
        "pageLength":this.rowsPerPage, 
        "lengthChange":this.showLengthChange,
        "columnDefs": [ 
          {
            "targets": 'nosort',
            "orderable": false
          } ,
          {
            "targets": "nosearch",
            "searchable": false
          },
          {
            "targets": this.dateColumnIndexes,
            "type": "date"
          },
          {
            "targets": this.centerColumnIndexes,
            "className": "tdCenter"
          }
        ],
        "deferRender": true,
        "scroller": true,
        "order": [this.orderColumnIndex, this.orderDirection],
        "searching": this.showSearch,
        "paging": this.showPaging,
        "info": this.showInfo,
        "lengthMenu":[
          [10,25,50,100,250,-1],
          [10,25,50,100,250,'All']
        ],
        "language":{
          "info": "Showing _START_ to _END_ of _TOTAL_ " + this.pluralDataName,
          "infoEmpty": "Showing 0 of 0 " + this.pluralDataName,
          "lengthMenu": "Show _MENU_ " + this.pluralDataName,
          "search": "Search " + this.pluralDataName,
          "zeroRecords": this.pluralDataName != "" ? "No matching " + this.pluralDataName + " found." : "No matching records found.",
          "infoFiltered": "(filtered from _MAX_ total " + this.pluralDataName + ")",
        }
      };
      
      //console.log("Datatable Created..");
      this.loading = true; 

      this.LoadDataAndInitializeTable();

    },
    methods: {
      //load user2 data via ajax get request
      LoadData: async function (url) {
        //console.log("load data called on dt"); 
        var urlToUse = url;
        if(url == null)
          urlToUse = this.dataUrl;

        this.id = this.componentKey;

        //get data from specified url:
        var dataToRetrieve = await $.ajax({
          method: "GET",
          contentType: "application/json; charset=utf-8",
          dataType: "json",
          url: urlToUse,
          //to change when we start protecting the API endpoints
          xhrFields: {
            withCredentials: false,
          },
          success: (result) => {
            //console.log("Load Data called and completed: ", result);
            this.allData = result; 
            //set loaded data to the first 'page' of data-- this allows the Datatable to render quickly while the remaining
            //data renders in the background after the first page
            this.loadedData = result.slice(0,this.rowsPerPage);
            //this.loadedData = result; //<----- loading all data here results in additional time to render the table
            this.loading = false;
            
            this.$emit("dtDataLoaded");
          },
        });

        return dataToRetrieve;
      },
      ReloadTable(){
        this.dt.ajax.reload(null,false);
      },
      //when the delete button is hit on the data row
      DeleteItem(id) {
        //console.log("delete item: " + id);
        var deleteUrl = this.deleteActionUrl + id;
        ajaxDeleteHelper(deleteUrl, (result) => {
          result;
          //console.log("deleted item via ajax", result);
          this.LoadData(); 
        });
      },
      LoadDataAndInitializeTable: async function (url) {
        //-------------------------------------------------------grab all data
        var dataToRetrieve = await this.LoadData(url);
        //console.log("done loading data", dataToRetrieve);
        //-------------------------------------------------------when data is loaded, update loaded data (see watcher below)
        this.loadedData = dataToRetrieve;
      }
    },
    //watch the loaded data variable-- if it's changed, reload the data table
    watch: {
      loadedData(val) {
        val;
        //console.log("loaded data changed");
        if(this.dt != null){ // destroys the datatable and resets TH widths to default
          this.dt.destroy();
          $("#table_" + this.id + " th").css('width','auto');
        }
        
        //console.log("setting up DT triggered by loadedData watch variable");
        //then render the new datatable using the initial settings:
        this.$nextTick(() => {
          this.dt = $("#table_" + this.id).DataTable(this.dtSettings).draw();
          var _this = this;
          $("#table_" + this.id).on("length.dt",function(e, settings, len){
            e;settings;
            //console.log(len); 
            _this.$emit("dtResultsPerPageChanged", len);
          });
        });
        
      },
    },
  
    components: { 
      LoadingGif 
    },
    emits:["dtUnmounted","dtDataLoaded","dtResultsPerPageChanged"],
    beforeUnmount(){
      //console.log("Unmounting dt. Let's destroy table with id: ", this.id); 
      if ($.fn.DataTable.isDataTable("#table_" + this.id)) {
          $("#table_" + this.id)
            .DataTable()
            .destroy(); 
        }
      this.$emit("dtUnmounted"); 
      
    }
  };
  </script>
  
  <style scoped>
  .editButton {
    margin-right: 10px;
  }
  .dtLucas {
      font-size: 14px;
  }
  .thclass{
    font-size:8px;
    word-break: break-word;
    white-space: nowrap;
  }
  
  .tdclass {
    text-align:left;
    min-width:65px;
  }
  .tdCenter{
    text-align:center;
  }
  .actionColumn{
    min-width: 120px;
  }
  .forIconEdit{
    margin-right:15px;
  }
  .dataTables_wrapper{
    display:flex;
    flex-direction: column;
  }
  th{
    font-size:12px !important;
    max-width:400px; 
    text-align:center !important;
  }
  :slotted(th){
    min-width:50px !important;
    font-size:12px !important;
    text-align:center !important;
  }
  :slotted(.actionColumn){
    min-width: 120px;
  }
  :slotted(.forIconEdit){
    margin-right:15px;
  }
  .tableContainerLucas{
    width:100%;
  }
  .dataTables_wrapper .dataTables_filter input{
    background-color:white;
    opacity:85%;
  }
  </style>
  